import Vue from 'vue'
import Router from 'vue-router'
import GertrudeForm from './../components/GertrudeForm.vue'
import Thankyou from './../components/Thankyou.vue'

Vue.use(Router)

export default new Router({
    routes: [
      { path: '/', component: GertrudeForm },
      { path: '/thankyou', component: Thankyou },
    ]
})
